export default __webpack_public_path__ + "static/getdata_new_kpi-e1c378c5436b016ad5c2eac09bd2a661.gif";